<template v-cloak>
  <article :class="cardClasses">
      <header>
        <Component class="card__title" v-if="title && !url" v-html="title" :is="heading"/>
        <Component class="card__title" v-if="title && url" :is="heading">
          <a class="card__link" :href="url" v-html="title" />
        </Component>
        <Chip v-if="latest_update" :date="latest_update" :active="active" />
      </header>
      <p class="card__excerpt" v-if="excerpt" v-html="excerpt" />

      <footer v-if="category || icon">
        <Icon v-if="icon" :icon="icon"/>
        <span v-if="category" class="sr-only">Incident type:</span>
        <span v-if="category" v-html="category" />
      </footer>

      <Icon icon="arrow-right" v-if="!!url" />

  </article>
</template>
<script>

import { defineComponent, computed, inject } from 'vue';
import Icon from "./Icon.vue";
import Chip from "./Chip.vue";

export default defineComponent( {
  name: 'Card',
  components: {
    Chip,
    Icon,
  },
  props: {
    post: {
      type: Object,
      default: () => ( {
        date: '',
        active: false,
        title: '',
        excerpt: '',
      } ),
    },
  },
  setup( props ) {
    const { active, excerpt, latest_update, title, type, url } = props.post;
    const { icon } = type;

    const cardClasses = computed( () => {
      return {
        card: true,
        'card--risk-item': 'risk' === props.post.post_type,
      };
    } );

    // Get the heading level from the parent component.
    const card_heading_level = inject( 'card_heading_level', 2 );

    // Set the heading level.
    const heading = computed( () => `h${ card_heading_level }` );

    return {
      active,
      title,
      excerpt,
      type,
      url,
      latest_update,
      icon,
      category: type.title,
      cardClasses,
      heading
    };
  }
} );
</script>
